export default __webpack_public_path__ + "static/media/card2@2x.2e8cfb28.png";